import { atom } from 'jotai';

export const itemPageMainBottomSheetStateAtom = atom({
    content: null,
    disableScroll: false,
    isOpen: false,
    title: null,
});

export const isStickyBidBarVisibleAtom = atom(false);
